import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LayoutPage from "../Layout";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import styled from "styled-components";

function AddPodcast() {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const [descriptionData, setDescriptionData] = useState("");
  const [url, setUrl] = useState("");
  const [formValues, setFormValues] = useState({
    topic: "",
    heading: "",
    description: "",
    podcastUrl: "",
  });

  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    topic: Yup.string()
      .max(10, "Topic must be at most 10 characters")
      .trim()
      .required("Topic is required"),
    heading: Yup.string()
      .max(50, "Heading must be at most 50 characters")
      .trim()
      .required("Heading is required"),

    description: Yup.string()
      .max(100, "Description cannot be more than 100 characters")
      .trim()
      .required("Description is required"),

    podcastUrl: Yup.string()
      .url("Podcast URL must be a valid URL")
      .required("Podcast URL is required"),
  });

  const handleSubmit = async (values) => {
    try {
      // e.preventDefault();

      // const values = {
      //   topic: title,
      //   heading,
      //   description: descriptionData,
      //   podcastUrl: url,
      // };

      let res = await axios.post(`admin-website/create-podcast`, values);
      // console.log("res ==> ", res);

      toast(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });

      navigate("/podcast");
      // }

      // navigate("/category", { state: { message: res.data.message } });
    } catch (errors) {
      if (errors.response.data.error) {
        toast(errors.response.data.error.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        });
      }
      // setDisabledSubmit(false);
    }
  };

  return (
    <>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      ADD PODCAST VIDEOS
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <Formik
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    <Form>
                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Topic: </label>
                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="topic"
                          name="topic"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Title"
                          // onChange={(e) => setTitle(e.target.value)}
                        />
                        <Error>
                          <ErrorMessage
                            name="topic"
                            className="error"
                            component="div"
                          />
                        </Error>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Heading</label>

                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="heading"
                          name="heading"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Heading"
                        />
                        <Error>
                          <ErrorMessage
                            name="heading"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Description</label>
                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="description"
                          name="description"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Description "
                        />
                        <Error>
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">URL</label>

                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="podcastUrl"
                          name="podcastUrl"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Podcast URL "
                        />
                        <Error>
                          <ErrorMessage
                            name="podcastUrl"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <button
                        type="submit"
                        className="Submit my-3 btn-lg w-20 mt-4 mb-0 "
                        style={{
                          // width: "200px",
                          borderRadius: "5px",
                          height: "50px",
                          marginLeft: "450px",
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                        // onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default AddPodcast;

const Error = styled.div`
  .error {
    color: red;
  }
`;
